import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  documentUploadErrorContent: () =>
    i18n.t(i18nKeys.workflow__documentUpload__errorContent),
  documentUploadErrorTitle: () =>
    i18n.t(i18nKeys.workflow__documentUpload__errorTitle),
  genericErrorContent: () => i18n.t(i18nKeys.workflow__generic__errorContent),
  genericErrorTitle: () => i18n.t(i18nKeys.workflow__generic__errorTitle),
  retry: () => i18n.t(i18nKeys.common__retry),
}
